<template>
    <v-alert
        @input="hideMaintenanceMessage"
        v-if="isAlertVisible"
        type="warning"
        border="left"
        dismissible
        colored-border
    >
        Perbaikan sistem
        <strong>17 September 2022, 03:00 - 03:30 WIB</strong>
        <br />
        Ukom Nakes tidak bisa diakses sementara pada waktu tersebut
    </v-alert>
</template>

<script>
import moment from '@/plugins/moment'
import {
    currentMaintenanceDate,
    dismissedMaintenances,
} from './currentMaintenance'

const LOCALSTORAGE_KEY = 'dismissedMaintenances'

export default {
    computed: {
        isAlertVisible() {
            return (
                !dismissedMaintenances.includes(
                    currentMaintenanceDate.toISOString()
                ) && moment() <= currentMaintenanceDate
            )
        },
    },

    methods: {
        hideMaintenanceMessage() {
            const result = dismissedMaintenances
            result.push(currentMaintenanceDate.toISOString())

            localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(result))
        },
    },
}
</script>
